import client from 'api/client';

export function get(docID: number) {
    const url = `document_forms/${docID}`;
    return client.get(url);
}

export function post(docID: number, payload: unknown) {
    const url = `fill_document_form/${docID}`;
    return client.post(url, payload);
}
